import React from 'react';

type IPaymentHistoryIcon = {
  size?: string;
  fill?: string;
};

const PaymentHistoryIcon: React.FC<IPaymentHistoryIcon> = props => {
  const { size = '20', fill = '#0276FE' } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_40_30924" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width={size} height={size} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_40_30924)">
        <path
          d="M10 17.5C8.08333 17.5 6.41333 16.8644 4.99 15.5933C3.56611 14.3228 2.75 12.7361 2.54167 10.8333H4.25C4.44444 12.2778 5.08667 13.4722 6.17667 14.4167C7.26722 15.3611 8.54167 15.8333 10 15.8333C11.625 15.8333 13.0033 15.2672 14.135 14.135C15.2672 13.0033 15.8333 11.625 15.8333 10C15.8333 8.375 15.2672 6.99639 14.135 5.86417C13.0033 4.7325 11.625 4.16667 10 4.16667C9.04167 4.16667 8.14583 4.38889 7.3125 4.83333C6.47917 5.27778 5.77778 5.88889 5.20833 6.66667H7.5V8.33333H2.5V3.33333H4.16667V5.29167C4.875 4.40278 5.73972 3.71528 6.76083 3.22917C7.78139 2.74306 8.86111 2.5 10 2.5C11.0417 2.5 12.0175 2.69778 12.9275 3.09333C13.8369 3.48944 14.6286 4.02417 15.3025 4.6975C15.9758 5.37139 16.5106 6.16306 16.9067 7.0725C17.3022 7.9825 17.5 8.95833 17.5 10C17.5 11.0417 17.3022 12.0172 16.9067 12.9267C16.5106 13.8367 15.9758 14.6283 15.3025 15.3017C14.6286 15.9756 13.8369 16.5106 12.9275 16.9067C12.0175 17.3022 11.0417 17.5 10 17.5ZM12.3333 13.5L9.16667 10.3333V5.83333H10.8333V9.66667L13.5 12.3333L12.3333 13.5Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default PaymentHistoryIcon;
